<script>
    import {Listeners} from "../../../constants/listeners";
    import {nextTick} from "vue";
    import ActionsContainer from "./actions-container.vue";
    import Button from "primevue/button";
    import Checkbox from "primevue/checkbox";

    export default {
        data() {
            return {
                include: true,
                rollUp: false,
                style: {},
                selectedTo: []
            }
        },
        props: {
            domainUrl: {
                type: String,
                required: false
            },
            domainId: {
                type: String,
                required: false
            },
            cntClass: {
                type: String,
                required: false,
                default: 'vuetable'
            },
            keywordsByPages: {
                type: Boolean,
                required: false,
                default: false
            },
        },

        mounted: function () {
            if(this.domainUrl === undefined && this.domainId !== undefined && this.domainId){
                this.include = false;
            }

            this.$emitter.on(Listeners.KS_TABLE_CHECKBOX_SELECTED, eventData => this.selectedTo = eventData);
        },
        methods: {
            createReport(page){
                let domainIds = this.selectedTo.slice();
                if(this.include && this.domainId){
                    domainIds.push(this.domainId);
                }
                const top = (new URL(window.location.href)).searchParams.get("top");
                let targetUrl = sprintf(
                    '/%s/%s?ids=%s',
                    window.locale,
                    page,
                    domainIds.join()
                )
                if (top) {
                    targetUrl += '&top=' + top
                }

                this.openTab(targetUrl);
            },

            createKeyordsByPages(page){
                let domainIds = this.selectedTo.slice(),
                    result = [];


                domainIds.forEach(id => {
                    const record = document.querySelector(`.orgtops td[data-id='${id}']`);
                    if(record){
                        result.push(encodeURIComponent(record.getAttribute('data-url')));
                    }
                });


                this.openTab("/" + window.locale + "/" + page + "?pages=" + result.join());
            },

            clearSelectedTo(){
                this.$emitter.emit(Listeners.KS_TABLE_CLEAR_SELECTED_TO);
            },

            openTab(url){
                window.open(url, '_blank');
            },
            handleScroll(){

                if(document.getElementsByClassName('ks-button-panel').length === 0){
                    return;
                }

                let table = document.getElementsByClassName(this.cntClass)[0],
                    panel = document.getElementsByClassName('ks-button-panel')[0];

                if((window.innerHeight - 200) >= (table.getBoundingClientRect().height + table.getBoundingClientRect().top + 70)){
                    this.style = {
                        top: (table.getBoundingClientRect().height + table.getBoundingClientRect().top + 70) + 'px',
                    }
                }else{
                    this.style = {
                        top: (window.innerHeight - 200) + 'px'
                    };
                }
            }

        },
        computed: {
            panelStyle(){
                return Object.assign({}, this.style, this.rollUp?{padding: '15px', opacity: 0.5}:{});
            }
        },
        watch: {
            selectedTo: function (val) {
                let self = this;
                nextTick(() => {
                    self.handleScroll();
                });

            }
        },

        created: function () {
            window.addEventListener('scroll', this.handleScroll);
            this.handleScroll();
        },
        destroyed: function () {
            window.removeEventListener('scroll', this.handleScroll);
        },
        components: {
            ActionsContainer,
            Button,
            Checkbox,
        }
    }
</script>

<template>
    <ActionsContainer :panelStyle="panelStyle" :selectedCount="selectedTo.length">
        <template #header v-if="domainUrl">
            <div class="field-checkbox">
                <Checkbox v-model="include" inputId="include" binary />
                <label for="include">{{$t('lang.main.table.components.domain_action.include_report')}} <span v-text="domainUrl"></span></label>
            </div>
        </template>
        <template #buttons>
            <Button @click="createReport('group')" :label="$t('lang.main.table.components.domain_action.group_report')" size="small" />
            <Button @click="createReport('compare')" :label="$t('lang.main.table.components.domain_action.site_compare')" size="small" />
            <Button @click="createReport('tools/domains-batch')" :label="$t('lang.main.table.components.domain_action.domains_batch')" size="small" />
            <Button v-if="keywordsByPages" @click="createKeyordsByPages('tools/keywords-by-pages')" :label="$t('lang.main.table.components.domain_action.keywords_by_pages')" size="small" />
            <Button @click="clearSelectedTo" :label="$t('lang.main.btn.clear')" severity="secondary" size="small" />
        </template>
    </ActionsContainer>
</template>
